import React from 'react';
import {iconName} from '@packages/systems/wfdl-Qualified';
import {Atom, withSystem, Plugins} from '@packages/systems/wfdl';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';
import {
  TList,
  TElement,
  TText,
  TRecord,
  TBoolean,
} from '@packages/systems/wfdl-ast';
import {getChildren} from '@packages/utilities/data-utils';

const basicPlugin = Plugins.name('Basic');

const ListItem = Atom.createRender(
  ({attributes, classes, generateAttributes, data, innerHTML, renderChild}) => {
    return (
      <li {...generateAttributes(attributes, classes)}>
        {/* @ts-expect-error - TS2322 - innerHTML union includes non-ReactNode array types (TODO platform: fix innerHTML type issues) */}
        {innerHTML || getChildren(data).map((child) => renderChild(child))}
      </li>
    );
  }
);

const config = createDevlinkAtom({
  displayName: 'List Item',
  icon: {type: 'Component', value: [basicPlugin, iconName('ListItem')]},
  constraints: {
    parent: [
      {is: 'List', rule: 'ExactlyOne'},
      // Uncomment to test escape hatch that essentially does the same thing as
      // the above rule.
      // {
      //   is: {
      //     check: node => node.type === 'List',
      //     name: 'A very important message',
      //   },
      //   rule: 'ExactlyOne',
      // },
    ],
  },
  showEmpty: true,
  showEmptyAsBlock: true,
  render: ListItem,
  fields: {
    children: withSystem(
      {
        label: 'Text',
        isBindable: true,
      },
      TList(TElement)
    ),
    list: withSystem(
      {private: true},
      TRecord({
        type: TText,
      })
    ),
    text: withSystem({private: true}, TBoolean),
  },
});

export default config;
